// Central config for the two-domain setup. The same build is deployed to both
// domains and switches behaviour by hostname:
//   websalon.in       → the SaaS operations product (owner login, dashboard, billing)
//   bookmysaloon.com  → the consumer-facing site customers use to book (/book/:slug)

const BOOKING_HOSTS = ["bookmysaloon.com", "www.bookmysaloon.com"];
const SAAS_HOSTS = ["websalon.in", "www.websalon.in"];

// Canonical production origins used when emitting cross-domain links.
export const SAAS_ORIGIN = "https://websalon.in";
export const BOOKING_ORIGIN = "https://bookmysaloon.com";

const host = typeof window !== "undefined" ? window.location.hostname : "";

// True when this build is being served from the consumer booking domain.
export const isBookingDomain = BOOKING_HOSTS.includes(host);

// Per-domain branding. The whole UI (logos, wordmark, tab title) reads from here,
// so each domain renders its own identity from the one shared build.
const BRANDS = {
    websalon: {
        key: "websalon",
        name: "WebSalon",
        // wordmark split for two-tone styling
        wordmark: ["Web", "Salon"],
        logo: "/websalon-logo.svg",
        tagline: "Salon & Spa Management Software",
    },
    bookmysaloon: {
        key: "bookmysaloon",
        name: "BookMySaloon",
        wordmark: ["BookMy", "Saloon"],
        logo: "/bookmysaloon-logo.svg",
        tagline: "Book your salon appointment online",
    },
};

export const brand = isBookingDomain ? BRANDS.bookmysaloon : BRANDS.websalon;

// Origin a shareable /book/:slug link should live on. On the booking domain (or
// local dev) use the current origin; from the SaaS domain point customers at the
// canonical booking domain so shared links are always bookmysaloon.com.
export function bookingOrigin() {
    if (typeof window === "undefined") return BOOKING_ORIGIN;
    if (isBookingDomain) return window.location.origin;
    if (SAAS_HOSTS.includes(host)) return BOOKING_ORIGIN;
    return window.location.origin; // localhost / preview — keep dev links working
}

export function bookingUrl(slug) {
    return `${bookingOrigin()}/book/${slug}`;
}

// Origin owner/operator links should point to from the consumer domain.
export function saasOrigin() {
    if (typeof window === "undefined") return SAAS_ORIGIN;
    if (!isBookingDomain) return window.location.origin;
    return SAAS_ORIGIN;
}
